/* This file is autogenerated, see readme.md for instructions */
import RewertLeftSvgIcon from '@bloomreach/banana-theme/icons/rewert-left.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const RewertLeftIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <RewertLeftSvgIcon />
    </Icon>
  );
});

RewertLeftIcon.displayName = 'RewertLeftIcon';

export default RewertLeftIcon;
